import React from "react";
import { type IFiltroProyectosVistaProps } from "../interfaces";
import {
    TextInput,
    Grid,
    Box,
    Text,
    Button,
    Select,
} from "@mantine/core";
import { IconClearAll, IconSearch, IconBuilding, IconMapPin } from "@tabler/icons-react";

const FiltroProyectosVista: React.FunctionComponent<IFiltroProyectosVistaProps> = ({
    consultarProyectos,
    filtro,
    limpiarFiltros,
    manejarCambioFiltroProyecto,
    listaProyectos,
    listaPaises
}) => {

    return (
        <Box pb="sm">
            <Grid gutter="sm" >
                <Grid.Col span={{ base: 12, md: 3 }}>
                    <Select
                        placeholder="Nombre del Proyecto"
                        name="ProyectoId"
                        size="xs"
                        searchable
                        clearable
                        leftSection={<IconBuilding size={15} />}
                        data={listaProyectos.map(p => ({
                            value: p.Id.toString(),
                            label: p.Nombre
                        }))}
                        value={filtro.ProyectoId ? filtro.ProyectoId.toString() : null}
                        onChange={(value) => {
                            manejarCambioFiltroProyecto("ProyectoId", value ? Number(value) : undefined)
                        }}
                        nothingFoundMessage="No se encontraron proyectos"
                    />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 3 }}>
                    <Select
                        placeholder="País"
                        name="PaisId"
                        size="xs"
                        searchable
                        clearable
                        leftSection={<IconMapPin size={15} />}
                        data={listaPaises ? listaPaises.map(p => ({
                            value: p.Id.toString(),
                            label: p.Nombre
                        })) : []}
                        value={filtro.PaisId ? filtro.PaisId.toString() : null}
                        onChange={(value) => {
                            manejarCambioFiltroProyecto("PaisId", value ? Number(value) : undefined)
                        }}
                        nothingFoundMessage="No se encontraron países"
                    />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 3 }}>
                    <TextInput
                        placeholder="Identificación del Proyecto"
                        name="NitProyecto"
                        size="xs"
                        leftSection={<IconSearch size={15} />}
                        maxLength={30}
                        value={filtro.NitProyecto || ""}
                        onChange={(event) => {
                            manejarCambioFiltroProyecto("NitProyecto", event.currentTarget.value)
                        }}
                    />
                </Grid.Col>
                <Grid.Col
                    span={{ base: 12, md: 3 }}
                    style={{
                        display: "flex",
                        alignItems: "flex-end",
                        justifyContent: "flex-end",
                        gap: "0.5rem",
                    }}
                >
                    <Button
                        onClick={limpiarFiltros}
                        color="primary"
                        variant="light"
                        size="compact-sm"
                        radius="lg"
                        fullWidth
                        rightSection={<IconClearAll opacity={1} size={12} />}
                    >
                        <Text fw={500} fz={11}>Limpiar</Text>
                    </Button>

                    <Button
                        onClick={() => consultarProyectos(filtro)}
                        color="primary"
                        variant="filled"
                        size="compact-sm"
                        radius="lg"
                        fullWidth
                        rightSection={<IconSearch opacity={1} size={12} />}
                    >
                        <Text fw={500} fz={11}>Consultar</Text>
                    </Button>
                </Grid.Col>

            </Grid>
        </Box>

    );
}

export default FiltroProyectosVista;